import React, { useState } from 'react';
import debounce from 'lodash/debounce';
// @ts-ignore
import { Tooltip } from '@pwc/appkit-react/lib/Tooltip';
import {
  FaSearch as SearchIcon,
  FaTimes as CloseIcon,
  FaRedo as RedoIcon,
} from 'react-icons/fa';

type SearchBarProps = {
  onCancel: () => void;
  onSearch: (search: string) => void;
  placeholder?: string;
  value: string;
  Component?: React.ElementType;
  withResetIcon?: boolean;
  reset?: () => void;
};

const SearchBar = ({
  onCancel,
  onSearch,
  placeholder,
  value,
  Component,
  withResetIcon,
  reset,
}: SearchBarProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>(value);

  const handleOpenSearch = () => {
    setIsOpen(!isOpen);
  };

  const handleSearch = debounce(searchText => onSearch(searchText), 500);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newSerchText = e.target.value;
    setSearchText(newSerchText);
    handleSearch(newSerchText);
  };

  const handleOnCancel = () => {
    handleOpenSearch();
    setSearchText('');
    onCancel();
  };

  if (Component) {
    return <Component onChange={handleOnChange} value={searchText} />; // eslint-disable-line react/jsx-no-bind
  }

  return (
    <>
      <div className="icons-container">
        {withResetIcon && reset && (
          <Tooltip content={'Reset grid to its default settings'} placement="top">
            <RedoIcon onClick={reset} />
          </Tooltip>
        )}
      </div>
      <div className="search-bar">
        {isOpen ? (
          (
            <div className="search-input-wrapper">
              <div className="input-wrapper">
                <input
                  autoFocus
                  type="text"
                  placeholder={placeholder}
                  onChange={handleOnChange} // eslint-disable-line react/jsx-no-bind
                  value={searchText}
                />
              </div>
              <div className="search-icon-wrapper">
                <CloseIcon
                  className="close-icon"
                  onClick={handleOnCancel} // eslint-disable-line react/jsx-no-bind
                />
              </div>
            </div>
          )
        ) : (
          <SearchIcon className="search-icon" onClick={handleOpenSearch} /> // eslint-disable-line react/jsx-no-bind
        )}
      </div>
    </>
  );
};

export default SearchBar;
